import { Link } from "react-router-dom";
import { Heart, ShieldCheck, Phone, Mail } from "lucide-react";

const SUPPORT_EMAIL = "support@scudononni.it";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#1E3A8A] text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <ShieldCheck size={36} className="text-[#22C55E]" />
              <h3 className="font-heading text-2xl font-extrabold">ScudoNonni</h3>
            </div>
            <p className="text-lg leading-relaxed text-blue-100 mb-5 max-w-md">
              Aiutiamo i nonni d'Italia a riconoscere le truffe online.
              Gratis, semplice, sempre al tuo fianco.
            </p>
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              data-testid="footer-support-email"
              className="inline-flex items-center gap-3 bg-white/10 hover:bg-white/20 rounded-2xl px-5 py-3 transition-colors"
            >
              <Mail size={22} className="text-[#22C55E]" />
              <span className="text-lg font-semibold">{SUPPORT_EMAIL}</span>
            </a>
          </div>

          <div>
            <h4 className="font-heading text-xl font-bold mb-4">Sezioni</h4>
            <ul className="space-y-3 text-lg">
              <li><Link to="/" data-testid="footer-link-home" className="hover:text-[#22C55E] transition-colors">Verifica un messaggio</Link></li>
              <li><Link to="/guida" data-testid="footer-link-guida" className="hover:text-[#22C55E] transition-colors">Guida Anti-Truffe</Link></li>
              <li><Link to="/numeri-utili" data-testid="footer-link-numeri" className="hover:text-[#22C55E] transition-colors">Numeri Utili</Link></li>
              <li><Link to="/chi-siamo" data-testid="footer-link-chisiamo" className="hover:text-[#22C55E] transition-colors">Chi Siamo</Link></li>
              <li><Link to="/contatti" data-testid="footer-link-contatti" className="hover:text-[#22C55E] transition-colors">Contatti</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-xl font-bold mb-4">Legale</h4>
            <ul className="space-y-3 text-lg">
              <li><Link to="/privacy" data-testid="footer-link-privacy" className="hover:text-[#22C55E] transition-colors">Privacy Policy</Link></li>
              <li><Link to="/cookie-policy" data-testid="footer-link-cookie" className="hover:text-[#22C55E] transition-colors">Cookie Policy</Link></li>
              <li><Link to="/termini" data-testid="footer-link-termini" className="hover:text-[#22C55E] transition-colors">Termini di Servizio</Link></li>
              <li><Link to="/trasparenza-ai" data-testid="footer-link-trasparenza" className="hover:text-[#22C55E] transition-colors">Trasparenza AI</Link></li>
              <li>
                <button
                  type="button"
                  data-testid="footer-link-cookie-prefs"
                  onClick={() => window.scudononniOpenCookieBanner && window.scudononniOpenCookieBanner()}
                  className="text-left hover:text-[#22C55E] transition-colors underline-offset-4"
                >
                  Modifica preferenze cookie
                </button>
              </li>
            </ul>

            <h4 className="font-heading text-xl font-bold mb-3 mt-6">Emergenze</h4>
            <a href="tel:112" data-testid="footer-emergency-112" className="flex items-center gap-3 bg-white/10 hover:bg-white/20 rounded-2xl px-4 py-3 mb-2 transition-colors">
              <Phone size={22} className="text-[#22C55E]" />
              <div><div className="text-sm text-blue-100">Emergenze</div><div className="text-xl font-bold">112</div></div>
            </a>
            <a href="tel:0646541" data-testid="footer-emergency-postale" className="flex items-center gap-3 bg-white/10 hover:bg-white/20 rounded-2xl px-4 py-3 transition-colors">
              <Phone size={22} className="text-[#22C55E]" />
              <div><div className="text-sm text-blue-100">Polizia di Stato</div><div className="text-lg font-bold">06 46541</div></div>
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/20 flex flex-col md:flex-row items-center justify-between gap-4 text-blue-100">
          <p className="text-base flex items-center gap-2">
            Fatto con <Heart size={18} className="text-[#22C55E] fill-[#22C55E]" /> per i nonni d'Italia
          </p>
          <p className="text-base">
            © {new Date().getFullYear()} ScudoNonni.it — Tutti i diritti riservati
          </p>
        </div>
      </div>
    </footer>
  );
}
